<template lang="html">

<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
<g>
  <path :fill="colors.basic" d="M44.3,50H5.7C2.6,50,0,47.4,0,44.3V5.7C0,2.6,2.6,0,5.7,0h38.5C47.4,0,50,2.6,50,5.7v38.5
    C50,47.4,47.4,50,44.3,50z M5.7,3.1c-1.4,0-2.6,1.2-2.6,2.6v38.5c0,1.4,1.2,2.6,2.6,2.6h38.5c1.4,0,2.6-1.2,2.6-2.6V5.7
    c0-1.4-1.2-2.6-2.6-2.6H5.7z"/>
  <path :fill="colors.basic" d="M25,39.6c-0.9,0-1.6-0.7-1.6-1.6V12c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v26
    C26.6,38.9,25.9,39.6,25,39.6z"/>
  <path :fill="colors.basic" d="M25,39.6c-0.4,0-0.8-0.2-1.1-0.5l-8.3-8.3c-0.6-0.6-0.6-1.6,0-2.2c0.6-0.6,1.6-0.6,2.2,0l7.2,7.2l7.2-7.2
    c0.6-0.6,1.6-0.6,2.2,0s0.6,1.6,0,2.2l-8.3,8.3C25.8,39.4,25.4,39.6,25,39.6z"/>
</g>
</svg>


</template>

<script lang="js">
  
  import {mapGetters} from 'vuex';

  export default  {
    name: 'download-doc',
    props: [],
    computed : {
      ...mapGetters({
        colors : 'basicColors'
      })
    }
}
</script>

<style scoped lang="scss">
  .add {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/icons/download-doc.vue